const home = {
    'home.video.title': 'あなたの世界を癒します',
    'home.video.btn': '仕組み',
    'home.pro.learnMore': '詳細はこちら',
    'home.join.title': '一緒に前進しましょう',
    'home.join.btn': 'パートナー」になり得る',
    'home.pro.title1': 'Snailcle S1の外観です',
    'home.pro.con1': 'スマートに見える、精神的な、ミニマルなデザイン、ないハードラインは、あなたの魂を滑らかにします。',
    'home.pro.btn': '発見',
    'home.pro.title2': 'セルフパワーAIリカンベントバイク R1',
    'home.pro.con2': 'Snailcle のヒーリング テクノロジー製品は、フィットネスの新しいオプションです。 ワンクリックのストレージにより、シンプルさ、ファッション性、安全性が戻ります。',
    'home.pro.title3': 'AI自発電気知能漕船機M 1',
    'home.pro.con3': '市場での静止バイクのほとんどから欠落している一つの事は、あなたが実際の自転車に乗っているときに上り坂と下り坂を取得する屋外の乗馬のシミュレーションです。このカタツムリの自転車は、斜面の変化に乗って体験することができます。',
    'home.app.title': '简単で便利です。',
    'home.app.con': 'snailcleアプリは、懸命に働くことから推測を排除します。何百ものガイド付きワークアウトやプログラムを閲覧したり、パーソナライズされた指標を確認したり、外出先でワークアウトを閲覧したり、来週のクラスをスケジュールしたりできます。',
    'home.app.btn': 'アプリを模索',
    'home.brand.title': '国際ブランド、世界標準。',
    'home.brand.con': '日本、韓国、台湾、香港、東南アジアで発売。ヨーロッパ、米国、中東でも同じ時期に販売されています。',
    'home.price.num': 'JPY 133968',
    'home.news.title': '最近のニュースです',
    'home.news.btn': 'たくさん読む',
    'homeR1.price.num': 'JPY 119019',
    'homeM1.price.num': 'JPY 104123',
}
const product = {
    'product.play.btn': '今放映します',
    'product.title': 'AIスマート自転車S1',
    'product.banner.title1': 'snailcle s1はあなたの世界を癒す。',
    'product.banner.con1': 'snailcle s1は、おしゃれでかわいい外観を持ち、暖かさ、癒し、テクノロジーに満ちたフィットネス製品です。',
    'product.banner.title2': '面白い乗馬とsnailcleアプリ。',
    'product.banner.con2': 'Snailcleアプリのサポートのもと、ランダムライド、プログラム、コース選択、試合、コーチコースなどを発見し、ライドを楽しむことができます。',
    'product.Exclusive.Features': '排他的な機能は、あなたの周りに働く! ',
    'product.banner.title3': '2つのスタイルは、常にあなたの好みに合ったものがあります。',
    'product.banner.con3': '説明した。',
    'product.gifBanner.title1': 'スマート',
    'product.gifBanner.con1': '違って見えて目立つシンプルなデザインで、ハードラインはありません。うまくだきこみ魂だ!',
    'product.gifBanner.title2': '自動高度調整です',
    'product.gifBanner.con2': '電源に接続すると、snailcle bikeはハンドルバーとシートの高さを最も低い位置に戻し、簡単にステップオーバーできます。',
    'product.gifBanner.title3': '微调整を',
    'product.gifBanner.con3': '少し調整したい場合でも、シートを離れる必要はなく、ハンドルバーのボタンを押すだけです。',
    'product.gifBanner.title4': 'AI姿勢検出',
    'product.gifBanner.con4': '特許の重力センサーの識別とai姿勢計算式をサポートして、snailcle自転車はあなたの体の動きの姿勢を検出し、あなたに最適な抵抗値をマッチングします。',
    'product.gifBanner.title5': 'AI姿勢分析',
    'product.gifBanner.con5': 'あなたが前進すると、抵抗は自動的にincraeseます。まっすぐに座ると、抵抗が自動的に減少します。',
    'product.imgBanner.title1': '自転車シミュレーション',
    'product.imgBanner.con1': '現実をシミュレートするループと、より難易度の高いスロープシミュレーションを提供し、ゲームをプレイしているような感覚を提供します。',
    'product.imgBanner.title2': 'フリーライダー',
    'product.imgBanner.con2': '何の目標も、コントロールも、そしてもちろん限界もありません。これはあなたの無料乗車です。私たちはあなたのデータを記録するためにのみ責任があります。',
    'product.imgBanner.title3': 'プログラム乗る',
    'product.imgBanner.con3': 'お客様の実用的なニーズを満たすために、抵抗を制御し、ステップ周波数データを検出することによって所望のトレーニング効果を達成する多機能サイクリングプログラムを設定しました。',
    'product.imgBanner.title4': '教育課程・現実',
    'product.imgBanner.con4': 'コースの中では、制限はなく、プロのコーチだけが、どのように訓練し、あなたに同行する方法を指導します。実際の生活の中で、離れて美しさと本当の傾斜を感じてから、あなたは完全に自分自身を解放し、より少ない時間でルートを完了しようとすることができます。',
    'product.imgBanner.title5': 'サイクルデータ概要',
    'product.imgBanner.con5': "各乗車のデータに加えて、点灯している正方形は、あなたが最近どれくらいの頻度で運動しているかをより直感的に感じることができます。",
    'product.proList.title1': '幅広で柔らかい鞍',
    'product.proList.con1': '快適さを保証するために幅広でソフトなサドルが装備されています。',
    'product.proList.title2': 'EMS磁気システム',
    'product.proList.con2': '特別に設計されたems磁気システムは、ジャーキングなしでスムーズなペダリングをサポートするために迅速な応答を備えています。',
    'product.proList.title3': 'ダンステールライトが',
    'product.proList.con3': 'テールライトカラーは、スクロールホイールのカラーとマッチし、あなたのライディングと一緒に踊ります。このライトは、bluetoothの接続または切断を示します。',
    'product.proList2.title1': '多機能グリップです',
    'product.proList2.con1': '3つの位置を持つハンドルバー:リラックス,スポーティ,競争',
    'product.proList2.title2': '固体体、最大範囲はあなたを満たすために。',
    'product.proList2.con2': 'ユーザ身長範囲:150cm-190cm。マックスユーザ重量はkg。',
    'product.proList2.title3': '寝モード',
    'product.proList2.con3': '機械が15分間無操作の場合、省エネ(24 v以下)のために磁気システムが停止します。',
    'product.specificationList.title1': '組み立て大きさ:',
    'product.specificationList.title2': 'ユーザ体重:',
    'product.specificationList.title3': '抵抗レベルです:',
    'product.specificationList.title4': '最大出力です:',
    'product.specificationList.title5': '電源:',
    'product.specificationList.title6': 'グリップ調整範囲&方式です:',
    'product.specificationList.title7': 'シート調整範囲&仕様です:',
    'product.specificationList.con6': '190 mm、電力調整',
    'product.specificationList.con7': 'このうち170 mm、電力/手動調整',
    'product.customerReviews': 'お客様のコメント。',
    'productR1.title': 'AI横型自転車R1',
    'productR1.banner.title1': 'snailcle R1あなたの世界を癒す。',
    'productR1.banner.con1': 'Snailcle R1 は、温かさ、癒し、テクノロジーに満ちた自己生成フィットネス製品で、幅広い人々に適しています。',
    'productR2.Exclusive.Features': '排他的な機能は、あなたの周りに働く!',
    'productR1.imgBanner.title1': '簡単に乗って',
    'productR1.imgBanner.con1': 'パワーの長さ調整、380mmの大きなスペースのリリース。簡単に乗ると下車、ユーザーの高さの範囲:1.5メートル-2メートル。',
    'productR1.imgBanner.title2': 'adujustment簡単',
    'productR1.imgBanner.con2': '長さ記憶システムと人間化されたデザインにより、最大5人の家族の個々の設定に対応でき、毎回調整する手間を省きます。',
    'productR1.imgBanner.title3': '自力',
    'productR1.imgBanner.con3': 'グリーンで環境に優しいセルフパワー方式を採用し、運動価値を高めています。使用中に発生する運動エネルギーを電気エネルギーに変換し、機械に連続的かつ十分な電力を供給することができます。また、携帯電話やパッドなどの外部機器を充電することもできます。',
    'productR1.imgBanner.title4': '乗って現実的なもの',
    'productR1.imgBanner.con4': "R1の抵抗はpms電磁制御システムを採用しています。これは超静かで、低atency、停止しない、安定して安全です。ltは1 ~ 36レベルにわたってミリ秒以内に加速または減速し、運動量と効率を維持します。これは、さまざまな人々の運動強度要件を満たすために、実際の屋外バイクに乗る経験の感覚を提供します。",
    'productR1.imgBanner.title5': '科学的に有効 ',
    'productR1.imgBanner.con5': "ハンドグリップ式心拍数機能を内蔵しているだけでなく、r1はリストバンド腕時計、心拍ベルト、アームバンドなどの心拍数配信機能を持つtoa心拍数機器との接続も可能です。snailcleアプリには、心拍計とリマインダー機能もある。",
    'productR1.proList.title1': '操作卓表示',
    'productR1.proList.con1': '快適さを保証するために幅広でソフトなサドルが装備されています。',
    'productR1.proList.title2': '二重手すりデザイン',
    'productR1.proList.con2': 'テールライトカラーは、スクロールホイールのカラーとマッチし、あなたのライディングと一緒に踊ります。このライトは、bluetoothの接続または切断を示します。',
    'productR1.proList2.title1': 'テクノロジーは運動を難しくしません',
    'productR1.proList2.con1': 'snailcleチームは、独立して運動はもはや退屈な作り、その統合インテリジェント抵抗制御、屋外シミュレーションサイクリング、ビジュアル認識インタラクティブpkチャレンジミニゲームアプリを開発しました。',
    'productR1.proList2.title2': 'あなたを見ることは私をリラックスさせ、あなたは体重を減らす、治療のすべての技術美容製品を使用します',
    'productR1.proList2.con2': 'R1は、初代s1alフィットネスバイクの審美的なデザインスタイルを踏襲している。可愛らしく、小さく、洗練された都会の家庭用テールライトとtftシャトルの5色ダイナミック呼吸ライトが、仕上げのタッチを果たしている。パワーリトラクタブルシートも強調snailcleブランドのユニークなデザイン哲学。',
    'productR1.proList2.title3': '伸縮自在、移動に便利',
    'productR1.proList2.con3': 'Snailcle ブランドのユニークなデザインコンセプトにより、ユーザーのすべての操作が簡単かつシンプルになります。',
    'productR1.banner.title3': 'TFTカラースクリーンが表示されます。距離、カロリーrpm、抵抗、パワー、心拍数モニタリングなどプログラムライド、フリーライド、ワンキーストレージ、位置記憶による容易な操作。外部心拍数デバイス接続。無線充電、usb充電ポートはすべて利用可能です。',
    'productR1.specificationList.information': '製品の基本スペック',
    'productR1.specificationList.title1': 'パワーです:',
    'productR1.specificationList.con1': '300W',
    'productR1.specificationList.title2': '給電方式です: ',
    'productR1.specificationList.con2': '自発電力です',
    'productR1.specificationList.title3': ' ',
    'productR1.specificationList.con3': '出口は必要ない',
    'productR1.specificationList.title4': '制御システムです: ',
    'productR1.specificationList.con4': '磁気制御です',
    'productR1.specificationList.title5': 'フライホイール重量: ',
    'productR1.specificationList.con5': '5.5kg',
    'productR1.specificationList.title6': '抵抗ギアです: ',
    'productR1.specificationList.con6': '1-36段の知的抵抗調整です',
    'productR1.specificationList.title7': '座席が上がります: ',
    'productR1.specificationList.con7': '空気圧制御調節です',
    'productR1.specificationList.title8': '踏み込み距離です: ',
    'productR1.specificationList.con8': '電動制御調整装置です',
    'productR1.specificationList.title9': 'デジタル時計の表示です: ',
    'productR1.specificationList.con9': 'つまみLED表示',
    'productR1.specificationList.title10': '表示パラメータです:',
    'productR1.specificationList.con10': '抵抗、時間、速度、カロリー、ピッチ、距離、心拍数、パワーです',
    'productR1.specificationList.title11': 'プログラムです: ',
    'productR1.specificationList.con11': '12のプログラムがあります',
    'productR1.specificationList.title12': ' ',
    'productR1.specificationList.con12': '3つのカウントダウンモードです',
    'productR1.specificationList.title13': ' ',
    'productR1.specificationList.con13': '5つのユーザーのカスタム位置の記憶の設定を選択します;',
    'productR1.specificationList.title14': 'アプリのサポートです: ',
    'productR1.specificationList.con14': 'Snailcle App',
    'productR1.specificationList.title15': 'USB充電口です: ',
    'productR1.specificationList.con15': 'あります',
    'productR1.specificationList.title16': 'は心拍装置に接続しました: ',
    'productR1.specificationList.con16': 'はいパルスセンサー付きです',
    'productR1.specificationList.title17': ' ',
    'productR1.specificationList.con17': '心拍放送機能を搭載した無線ウェアラブルデバイスに対応',
    'productR1.specificationList.title18': '設備用ブラケットです: ',
    'productR1.specificationList.con18': 'あります',
    'productR1.specificationList.title19': '身長の範囲です: ',
    'productR1.specificationList.con19': '150cm-190cm',
    'productR1.specificationList.title20': 'ユーザー最大荷重です:',
    'productR1.specificationList.con20': '120kg',
    'productR1.specificationList.title21': '組み立て後の最小サイズです:',
    'productR1.specificationList.con21': '1335*652*1218mm',
    'productR1.specificationList.title22': '組み立て後最大サイズです:',
    'productR1.specificationList.con22': '1615*652*1218mm',
    'productR1.specificationList.Package&LoadingQty': 'パッケージ仕様&キャビネット量です',
    'productR1.specificationList.title26': '正味重量です:',
    'productR1.specificationList.con26': '42kg',
    'productR1.specificationList.title27': '毛重です:',
    'productR1.specificationList.con27': '49kg',
    'productR1.specificationList.title28': '外箱サイズです:',
    'productR1.specificationList.con28': '1300*355*625mm',
    'productR1.specificationList.title29': '20’/40’/40HQ:',
    'productR1.specificationList.con29': '88 / 189 / 216',
    'productM1.title': 'AIボーリングマシンM1',
    'productM1.banner.title1': 'snailcle m1あなたの世界を癒す。',
    'productM1.banner.con1': 'Snailcle M1は、キュートでコンパクトな外観と簡単に収納できる、キュートで絶妙なアーバンホームフィットネス製品です。',
    'productM1.banner.title2': 'Snailcle アプリでボートを漕ぐ',
    'productM1.banner.con2': 'Snailcle アプリのサポートにより、無制限のローイング、ローイング心拍数トレーニング、さまざまなローイング プログラム コースの演習を行うことができ、データを使用してあらゆる努力と成果を記録することができます。',
    'productM1.imgBanner2.title1': '無制限のボート遊び',
    'productM1.imgBanner2.con1': 'フリーローイングでは目標や制限はなく、アプリパネルに各パドルのリアルタイムデータが表示され、タイムリーなフィードバックが提供されます。',
    'productM1.imgBanner2.title2': 'ローイング心拍数トレーニング ',
    'productM1.imgBanner2.con2': 'ローイング心拍数トレーニングは、心拍数の目標を設定してトレーニング強度を調整する運動方法です。 このようにして、注目する必要があるのは心拍数だけです。',
    'productM1.imgBanner2.title3': 'プログラムローイング',
    'productM1.imgBanner2.con3': '実際のニーズに応えるために、抵抗の制御と漕ぎ回数データのモニタリングにより理想的な運動効果を実現するためのさまざまな漕ぎトレーニングプログラムを用意しています。',
    'productM1.imgBanner.title1': '家族のための新しい選択',
    'productM1.imgBanner.con1': '700 mmのスライドレール動力移動空間。1.5 ~ 2メートルの高さで300ポンド(約300 kg)の体格の強い男性でも快適に漕ぐことができる。',
    'productM1.imgBanner.title2': 'シンプリシティー、ファッションや安全を',
    'productM1.imgBanner.con2': '1つのボタンのストレージで、わずか0.5平方メートルを取り、創造的に伝統的なボート機械の問題を解決します。',
    'productM1.imgBanner.title3': '自力',
    'productM1.imgBanner.con3': 'グリーンで環境に優しいセルフパワー方式を採用し、運動価値を高めています。使用中に発生する運動エネルギーを電気エネルギーに変換し、機械に連続的かつ十分な電力を供給することができます。また、携帯電話やパッドなどの外部機器を充電することもできます。',
    'productM1.imgBanner.title4': '漕艇沈黙を守ってきた',
    'productM1.imgBanner.con4': "m1の抵抗はpms制御システムを採用し、非常に静かで低遅延、ラグがなく、安定した安全な性能を提供します。16レベルの抵抗選択により、運動の慣性と高効率を維持し、現実的な漕ぎの体験を実現し、さまざまなグループの人々のための運動の強度要件を満たします。",
    'productM1.imgBanner.title5': '科学的に有効',
    'productM1.imgBanner.con5': "ハンドグリップ機能を内蔵しているほか、リストバンド、腕時計、心拍ベルト、アームバンドなど、心拍放送機能を持つすべての心拍機器に接続することができます。snailcleアプリには、心拍数モニターとリマインダー機能もあります。",
    'productM1.proList2.title1': '創造性があなたの世界を癒し、テクノロジーを使用して均一性を根絶し、治療的なテクノロジーの美しさを実現します',
    'productM1.proList2.con1': 'm1は、初代s1 alfitnessバイクの審美的なデザインスタイルを踏襲している。可愛らしく、小さく、洗練された都会の家のためのスタイルテールライトとtftシャトル5色ダイナミック呼吸ライトが仕上げを果たしている。パワーリトラクタブルシートもsnailcleブランドのユニークなデザイン哲学を強調しています。',
    'productM1.proList2.con2': 'Snailcle ブランドのユニークなデザインコンセプトにより、ユーザーのすべての操作が簡単かつシンプルになります。',
    'productM1.proList2.title2': '伸縮自在、移動に便利',
    'productM1.banner.title3': 'TFTカラー画面表示:時間、距離、カロリー、カウントspm、抵抗、電力、心拍数の監視など;プログラム、自由、ワンボタンのストレージ、簡単な操作外部心拍数デバイスの接続、wita usb充電インターフェースを装備。',
    'productM1.specificationList.title1': 'パワーです:',
    'productM1.specificationList.con1': '300W',
    'productM1.specificationList.title2': '給電方式です: ',
    'productM1.specificationList.con2': '自発電力です',
    'productM1.specificationList.title3': '収納方法です:',
    'productM1.specificationList.con3': '電動伸縮式収納装置です',
    'productM1.specificationList.title4': '抵抗方式です:',
    'productM1.specificationList.con4': '磁気抵抗装置です',
    'productM1.specificationList.title5': 'フライホイール重量: ',
    'productM1.specificationList.con5': '2kg',
    'productM1.specificationList.title6': '抵抗ギアです: ',
    'productM1.specificationList.con6': '1-16段の知的抵抗調整です',
    'productM1.specificationList.title7': 'レール材質です:',
    'productM1.specificationList.con7': 'アルミ合金',
    'productM1.specificationList.title8': 'デジタル時計の表示です: ',
    'productM1.specificationList.con8': 'つまみLED表示',
    'productM1.specificationList.title9': '表示パラメータです:',
    'productM1.specificationList.con9': '抵抗、時間、カロリー、距離、心拍数、回数、頻度です',
    'productM1.specificationList.title10': 'Programs: ',
    'productM1.specificationList.con10': '12のプログラムがあります',
    'productM1.specificationList.title11': ' ',
    'productM1.specificationList.con11': '3つのカウントダウンモードです',
    'productM1.specificationList.title12': 'アプリのサポートです: ',
    'productM1.specificationList.con12': 'Snailcle App',
    'productM1.specificationList.title13': 'USB充電口です: ',
    'productM1.specificationList.con13': 'あります',
    'productM1.specificationList.title14': 'は心拍装置に接続しました: ',
    'productM1.specificationList.con14': 'はい、システムは、パルスを表示するbluetoothワイヤレス摩耗自動接続をサポートすることができます',
    'productM1.specificationList.title15': '設備用ブラケットです: ',
    'productM1.specificationList.con15': 'あります',
    'productM1.specificationList.title16': '身長の範囲です: ',
    'productM1.specificationList.con16': '150cm-190cm',
    'productM1.specificationList.title17': 'ユーザー最大荷重です:',
    'productM1.specificationList.con17': '120kg',
    'productM1.specificationList.title18': '組み立て後の最小サイズです:',
    'productM1.specificationList.con18': '1188*572*847mm',
    'productM1.specificationList.title19': '組み立て後最大サイズです:',
    'productM1.specificationList.con19': '1784*572*847mm',
    'productM1.specificationList.Package&LoadingQty': 'パッケージ仕様&キャビネット量です',
    'productM1.specificationList.title20': '正味重量です:',
    'productM1.specificationList.con20': '30kg',
    'productM1.specificationList.title21': '毛重です:',
    'productM1.specificationList.con21': '37kg',
    'productM1.specificationList.title22': '外箱サイズです:',
    'productM1.specificationList.con22': '1260*355*650mm',
    'productM1.specificationList.title23': '20’/40’/40HQ:',
    'productM1.specificationList.con23': '100 210 / 244',
}
const distributor = {
    'distributor.title': '販売支援',
    'distributor.toBecome': '相互の成功のためのパートナーシップ',
    'distributor.con': '地域ブランド許可',
    'distributor.con1': 'ブランド提携のイニシアティブ',
    'distributor.con2': '全世界の代理店パートナーシップ機会(共同ブランド構築)',
    'distributor.con3': '共同革新品',
    'distributor.con4': '共有技術を通して',
    'distributor.contact': 'できるだけ早くご連絡させていただきます。',
    'distributor.phone': '電話:',
    'distributor.email': 'メール:',
    'distributor.workingHours': '勤务时间:',
    'distributor.workingHours.con': '9am - 6pm(GMT+8)',
    'distributor.join': '私たちに参加して、snailcleはあなたの信頼できるグローバルフィットネスブランドになります。'
}
const afterSales = {
    'afterSales.title': '後販売',
    'afterSales.Video':'組み立てビデオです',
    'afterSales.click.download':'クリックするだけで下载:',
    'afterSales.app.download':'Appダウンロード出来ます。',
    'afterSales.con1':'「snailcle」はapple & google playストアで直接検索できます。',
    'afterSales.con2':'以下のqrコードをスキャンしてダウンロードすることもできます。',
    'afterSales.Assembly':'組み立てガイド',
    'afterSales.Manual':"ユーザのマニュアル",
    'afterSales.FunctionGuide': '機能ガイド'
}
const about = {
    'about.title': '私たちは',
    'about.Story': 'ブランド物語。',
    'about.Story.con1': `snailcleは、フィットネス製品に特化した革新的なフィットネス技術企業です。同社の使命は、かさばる、退屈で黒い従来のフィットネス製品よりも、製品の独創性、新規性、知性、同質性、コンテンツを強調し、若い家族のための「あなたの最初のフィットネスマシン」を作成することです。SNAILCLEのデビューAI-sensing専用器具によって開発された自転車S1会社の共同創立者兼パートナーから目孫晧博士は中国科学技術大学革新概念建設でチームをリードするIDデザイン先進多次元力認識センサー・AI姿勢分析専攻アルゴリズムおよび态学識別アルゴリズム2022年9月には「量産にはいるです同年、アメリカのクラウドファンディングプラットフォームであるkickstarterで、独立した研究開発と独立したブランドを立ち上げ、成功を収めました。その後、香港、台湾、韓国、日本、アメリカ、ドイツ、イスラエル、インド、ロシアなどの市場で販売され、国際ブランド戦略の第一歩を踏み出しました。`,
    'about.Story.con2': 'snailcleファミリーシリーズ製品r1リキャンベントバイク& m1ローイングマシン、および将来の新製品は、すべてのより特徴的な製品の特徴を持つすべてのsnailcleファミリー製品を鼓舞パワーリフティング、電力拡張、および電力貯蔵の一貫したデザインスタイルに従っています。',
    'about.Profile': '導入',
    'about.technology': 'snailcle(アモイ)技術有限公司',
    'about.join': 'snailcleは、女性の健康管理に焦点を当てた国際的なホームフィットネブランドです。小売業者、流通業者、on lineチャネル、ショッピングモール、スーパーマーケットの皆様のご参加を心よりお待ちしております。',
    'about.phone': 'ホットライン(Hot line):',
    'about.email': 'メール:',
    'about.address': '住所: ',
    'about.address.con': '7th Floor, No.36, Bannan Road, Haicang District,Xiamen, China '
}
const contact = {
    'contact.title': '私たちに連絡します',
    'contact.con1': '当社の製品とソリューションにご興味がありますか?',
    'contact.con2': '当社の製品を購入したいですか?',
    'contact.con3': '私たちのブランド大使になる?',
    'contact.con4': 'ディーラーになりますか?',
    'contact.now': '今すぐ連絡します!',
    'contact.message': "私たちはあなたからのご連絡をお待ちしています。フォームからメッセージをお送りください。"
}
const support= {
    'support.title': '支援',
    'support.con1': 'サポートフォームを使用して、当社の専門家から専門的なサポートを受けてください。フォームに記入することで、お客様の問題を迅速かつ効果的に解決することができます。ありがとう!',
    'support.con2': '素敵な自転車をお買い上げいただきありがとうございます!',
    'support.send.email': '私たちにメールを送ってください:',
    'support.con3': "何でも言ってくれ!24 ~ 28時間以内にご連絡いたします。",
    'support.chat': '私たちと会話をしました',
    'support.con4': 'すぐにサポートを必要とする問題や質問がある場合は、以下をクリックしてカスタマーサービス担当者とライブでチャットできます。',
    'support.message': 'ワンクリック・メッセージ',
    'support.con5': "私たちがavaliableでない場合は、左にメールを送ってください。",
}
const shippingPolicy = {
    'shippingPolicy.title': '海運政策',
    'shippingPolicy.con1': '素敵な自転車をお買い上げいただきありがとうございます!',
    'shippingPolicy.con2': '当社の目標は、お客様に最高の輸送手段を提供し、製品を迅速かつ安全にお届けすることです。販売地域とそれぞれの配送方針には特にご注意ください。',
    'shippingPolicy.con3': '注文の配送スケジュールは2つの部分に分かれています:',
    'shippingPolicy.time': '処理時間:',
    'shippingPolicy.time.con': '48営業時間以内に',
    'shippingPolicy.method': '海運方法:',
    'shippingPolicy.method.con': 'Fedex & UPS & DPD & TNT...',
    'shippingPolicy.ShippingTime': '海運時間:',
    'shippingPolicy.ShippingTime.con': '5 ~ 7営業日',
    'shippingPolicy.ShippingFee': '海運费:',
    'shippingPolicy.ShippingFee.con': '7万円以上なら送料無料でご註文いただけます',
}
const formType = {
    'form.label.Name': '名前',
    'form.label.Company': 'あなたの社名',
    'form.label.email': '電子メール',
    'form.label.Comment': 'あなたのコメント',
    'form.label.Phone': '電話',
    'form.label.Country': 'あなたの国',
    'form.label.Model': '製品モデル',
    'form.label.from': '買い入れ地',
    'form.label.Purchase': '購入の証',
    'form.label.Description': '記述',
    'form.btn.sub': '提出連絡',
    'form.message.valid.email': '入力が有効なメールではありません!',
    'form.message.enter.email': 'メールを入力してください!',
    'form.message.phone': '電話番号を入力してください。',
    'form.message.comment': 'ご意見をご入力ください',
    'form.message.enter.comment': 'ここにコメントを残してください',
    'form.message.des': 'ここにあなたの記述を残してください',
    'form.message.des.input': 'あなたの説明を入力してください',
    'form.message.purchase.input': '購入証明書を入力してください。',
    'form.message.from': 'あなたの購入を入力してください!',
    'form.message.Model': '製品モデルを入力してください。',
}
const whereToBuy = {
    'wheretobuy.title1': '購入ルート',
    'wheretobuy.con': '私たちの公式購入ルートを訪問してください。',
    'wheretobuy.title2': 'その他の購入チャネル',
    'wheretobuy.Btn': '購入します',
}
const header = {
    'header.menus.home': 'ホーム・ページ',
    'header.menus.product': '製品',
    'header.menus.news': 'ニュース',
    'header.menus.support': '販売支援',
    'header.menus.after': 'アフターサービス',
    'header.menus.about': '私たちについてです',
    'header.menus.contact': '私たちに連絡します',
    'header.menus.proS1': 'AIスマート自転車S1',
    'header.menus.proR1': 'AI横型自転車R 1',
    'header.menus.proM1': 'AIボーリングマシンM 1'
}
const footer = {
    'footer.menus.about': 'について',
    'footer.menus.about.Contact': '連絡',
    'footer.menus.about.About': '私たちについてです',
    'footer.menus.about.Distributor': 'ディーラーになります',
    'footer.menus.support': 'サービス',
    'footer.menus.support.Support': '支援',
    'footer.menus.support.Shipping': '海運政策',
    'footer.menus.support.Return': '返品・返金ポリシーです',
    'footer.menus.support.Refund': '払い戻しポリシーです。',
    'footer.menus.support.Intellectual': '知的財産権',
    'footer.menus.support.Privacy': 'プライバシーポリシーを',
    'footer.menus.support.Terms': 'サービス規約です',
    'footer.menus.INFO': '情報',
    'footer.menus.INFO.App': 'App',
    'footer.menus.INFO.News': 'ニュース',
    'footer.menus.INFO.FAQ': 'FAQ',
    'footer.menus.INFO.Installation': 'インストール',
    'footer.SUBSCRIBE': '購読私たちに',
    'footer.enterAddress': 'メールアドレスを入力します。',
    'footer.Submit': '提出',
    'footer.pages.news.title': 'Snailcleニュース',
    'footer.pages.news.publish': '発表',
    'footer.pages.Support.title': '販売支援',
    'footer.bottom.con': '©2020 酷蜗牛（厦门）科技有限公司 版权所有 闽ICP备2024032604号-1'
}
const download = {
    'download.meta.title': 'Snailcle - スマートフィットネスアプリ',
    'download.title': 'Snailcle',
    'download.subtitle': 'より良いフィットネス体験のためのスマートなパートナー。',
    'download.status.ios': 'App Store を開いています...',
    'download.status.android': 'Google Play を開いています...',
    'download.store.apple.small': 'Download on the',
    'download.store.apple.large': 'App Store',
    'download.store.google.small': 'GET IT ON',
    'download.store.google.large': 'Google Play',
    'download.store.action': '入手',
    'download.qr.ios': 'iOS QRコード',
    'download.qr.android': 'Android QRコード',
    'download.footer.company': '©{year} SNAILCLE (XIAMEN) TECHNOLOGY CO., LTD.'
}
export default {
    ...home,
    ...product,
    ...distributor,
    ...afterSales,
    ...about,
    ...contact,
    ...support,
    ...shippingPolicy,
    ...formType,
    ...whereToBuy,
    ...header,
    ...footer,
    ...download
}
